module.exports = __webpack_public_path__ + "static/media/home copy.b32405f4.png";